import AccountBalanceIcon from '@cp/src/assets/icons/AccountBalanceIcon';
import CopyToClipboardIcon from '@cp/src/assets/icons/CopyToClipboardIcon';
import GroupGSTIcon from '@cp/src/assets/icons/GroupGSTIcon';
import LocationOutlineIcon from '@cp/src/assets/icons/LocationOutlineIcon';
import MailIcon from '@cp/src/assets/icons/MailIcon';
import PersonOutlineIcon from '@cp/src/assets/icons/PersonOutlineIcon';
import { Popper, PopperContent, PopperTrigger } from '@cp/src/components/Popper/Popper';
import { Tooltip, TooltipContent, TooltipTrigger } from '@cp/src/components/TooltipV2/TooltipV2';
import { ClickTopCopy, copyToClipboard } from '@cp/src/utils/commonUtils';
import GridContainer from '@navi/web-ui/lib/layouts/Grid/GridContainer/GridContainer';
import { Button } from '@navi/web-ui/lib/primitives';
import cx from 'classnames';
import dayjs from 'dayjs';
import { useState } from 'react';
import { ISherlock } from '../../interfaces/CaseDetail.type';
import { FILTERS } from '../../interfaces/SkipTracing.type';
import styles from './index.module.scss';
import WorkIcon from '@cp/src/assets/icons/WorkIcon';
import HashtagIcon from '@cp/src/assets/icons/HashTagIcon';
import OutLineInfoIcon from '@cp/src/assets/images/icons/OutLineInfoIcon';
import { addClickstreamEvent } from '@cp/src/service/clickStreamEventService';
import { CLICKSTREAM_EVENT_NAMES } from '@cp/src/service/clickStream.constant';
import InfoThickIcon from '@cp/src/assets/images/icons/InfoThickIcon';

interface ISherlockProps {
  data: ISherlock;
}

const GstCard = (props: ISherlockProps) => {
  const { data } = props;
  const tooltipCopy = 'Click to copy';
  const tooltipArrowColor = 'var(--tooltip-background-color)';
  const [emailTooltip, setEmailTooltip] = useState(tooltipCopy);
  const [addressTooltip, setAddressTooltip] = useState(tooltipCopy);
  const [gstinTooltip, setGstinTooltip] = useState(tooltipCopy);
  const [businessNameTooltip, setBusinessNameTooltip] = useState(tooltipCopy);
  const formattedDate = dayjs(Number(data?.date)).format('DD MMM, YYYY');
  const [emailTooltipArrow, setEmailTooltipArrow] = useState(tooltipArrowColor);
  const [addressTooltipArrow, setAddressTooltipArrow] = useState(tooltipArrowColor);
  const [gstinTooltipArrow, setGstinTooltipArrow] = useState(tooltipArrowColor);
  const [businessNameTooltipArrow, setBusinessNameTooltipArrow] = useState(tooltipArrowColor);
  const [registeredNameTooltip, setRegisteredNameTooltip] = useState(tooltipCopy);
  const [registeredNameTooltipArrow, setRegisteredNameTooltipArrow] = useState(tooltipArrowColor);
  const formatString = (inputString: string) => {
    if (inputString) {
      const formattedString =
        inputString.charAt(0).toUpperCase() + inputString.slice(1).toLowerCase();
      return formattedString;
    }
  };

  const handleEmailCopy = (text: string) => {
    addClickstreamEvent(CLICKSTREAM_EVENT_NAMES.LH_SKIPTRACING_GST_EMAIL_COPY);
    ClickTopCopy({
      text: text,
      setArrowColor: setEmailTooltipArrow,
      setTooltipContent: setEmailTooltip
    });
  };
  const handleAddressCopy = (text: string) => {
    addClickstreamEvent(CLICKSTREAM_EVENT_NAMES.LH_SKIPTRACING_GST_ADDRESS_COPY);
    ClickTopCopy({
      text: text,
      setArrowColor: setAddressTooltipArrow,
      setTooltipContent: setAddressTooltip
    });
  };
  const handleGstinCopy = (text: string) => {
    addClickstreamEvent(CLICKSTREAM_EVENT_NAMES.LH_SKIPTRACING_GST_GSTIN_COPY);
    ClickTopCopy({
      text: text,
      setArrowColor: setGstinTooltipArrow,
      setTooltipContent: setGstinTooltip
    });
  };
  const handleBusinessNameCopy = (text: string) => {
    addClickstreamEvent(CLICKSTREAM_EVENT_NAMES.LH_SKIPTRACING_GST_BUSINESS_NAME_COPY);
    ClickTopCopy({
      text: text,
      setArrowColor: setBusinessNameTooltipArrow,
      setTooltipContent: setBusinessNameTooltip
    });
  };
  const handleRegisteredNameCopy = (text: string) => {
    addClickstreamEvent(CLICKSTREAM_EVENT_NAMES.LH_SKIPTRACING_GST_REGISTERED_NAME_COPY);
    ClickTopCopy({
      text: text,
      setArrowColor: setRegisteredNameTooltipArrow,
      setTooltipContent: setRegisteredNameTooltip
    });
  };
  const getTagColor = (status: string) => {
    switch (status) {
      case FILTERS.ACTIVE:
        return styles.Active;
      case FILTERS.INACTIVE:
        return styles.Inactive;
      case FILTERS.CANCELLED:
        return styles.Cancelled;
      case FILTERS.SUSPENDED:
        return styles.Suspended;
      case FILTERS.PROVISIONAL:
        return styles.Provisional;
    }
  };
  return data?.businessName || data?.businessAddress || data?.email || data?.registeredNames ? (
    <GridContainer className={styles.cardContainer}>
      {data?.isNew && <div className={styles.newContainer}>New</div>}
      <div className={styles.gstTag}>
        <GroupGSTIcon />
        <div className={'flex row items-center gap-[2px]'}>
          GST
          <Tooltip placement="bottom">
            <TooltipTrigger className="tooltipContent">
              <InfoThickIcon width={16} height={16} fillColor="var(--blue-dark)" />
            </TooltipTrigger>
            <TooltipContent className="tooltipWrapper">
              {data?.infoText ? data?.infoText : 'Bussiness Details'}
            </TooltipContent>
          </Tooltip>
        </div>
      </div>
      <div className={'w-[98%]'}>
        <div className={'flex justify-end absolute right-0'}>
          <div className={styles.dateContainer}>Updated on {formattedDate}</div>
        </div>
        <GridContainer className={styles.gstCardContent}>
          <div className={styles.topLeftContainer}>
            <div className={styles.BusinessContainer}>
              <div className={styles.BusinessName}>
                <div>
                  <AccountBalanceIcon />
                </div>
                <div className={styles.subBContainer}>
                  <div className={'flex flex-row gap-[2px]'}>
                    <div className={styles.BusinessId}>
                      {data?.businessName ? (
                        data?.businessName?.length > 17 ? (
                          <Tooltip
                            placement="top-start"
                            hiddenPadding={0}
                            hideStrategy="referenceHidden"
                          >
                            <TooltipTrigger asChild={true} ellipsis>
                              <div className={'max-w-[145px]'}>{data?.businessName}</div>
                            </TooltipTrigger>
                            <TooltipContent className="tooltipWrapper">
                              {data?.businessName}
                            </TooltipContent>
                          </Tooltip>
                        ) : (
                          data?.businessName
                        )
                      ) : (
                        'NA'
                      )}
                    </div>
                    <div className={styles.icon}>
                      <Tooltip placement="top">
                        <TooltipTrigger className="tooltipContent">
                          <Button
                            variant="text"
                            onClick={() => handleBusinessNameCopy(data?.businessName || '')}
                            disabled={!data?.businessName}
                          >
                            {data?.businessName ? (
                              <CopyToClipboardIcon width={16} height={16} />
                            ) : null}
                          </Button>
                        </TooltipTrigger>
                        <TooltipContent
                          className="tooltipWrapper"
                          arrowColor={businessNameTooltipArrow}
                        >
                          {businessNameTooltip}
                        </TooltipContent>
                      </Tooltip>
                    </div>
                  </div>
                  <div className={styles.typeBusiness}>Business Name</div>
                </div>
                {data?.status && (
                  <div className={cx(styles.status, getTagColor(data?.status))}>
                    {formatString(data?.status)}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className={styles.topMiddleContainer}>
            <div className={styles.registeredName}>
              <div>
                <PersonOutlineIcon width={20} height={20} fill="var(--grayscale-3)" />
              </div>
              <div className={styles.registerId}>
                {data?.registeredNames?.length ? (
                  <>
                    <div className={'flex flex-row gap-[4px]'}>
                      {data?.registeredNames[0]?.length > 14 ? (
                        <Tooltip
                          placement="top-start"
                          hiddenPadding={0}
                          hideStrategy="referenceHidden"
                        >
                          <TooltipTrigger asChild={true} ellipsis>
                            <div className={'max-w-[180px]'}>{data?.registeredNames[0]} </div>
                          </TooltipTrigger>
                          <TooltipContent className="tooltipWrapper">
                            {data?.registeredNames[0]}
                          </TooltipContent>
                        </Tooltip>
                      ) : (
                        data?.registeredNames[0]
                      )}
                      <div className={styles.icon}>
                        <Tooltip placement="top">
                          <TooltipTrigger className="tooltipContent">
                            <Button
                              variant="text"
                              onClick={() =>
                                handleRegisteredNameCopy(data?.registeredNames?.[0] || '')
                              }
                            >
                              {data?.registeredNames[0] ? (
                                <CopyToClipboardIcon width={16} height={16} />
                              ) : null}
                            </Button>
                          </TooltipTrigger>
                          <TooltipContent
                            className="tooltipWrapper"
                            arrowColor={registeredNameTooltipArrow}
                          >
                            {registeredNameTooltip}
                          </TooltipContent>
                        </Tooltip>
                      </div>
                    </div>
                    <span>
                      {data?.registeredNames?.length > 1 && (
                        <Popper placement="top">
                          <PopperTrigger className={styles.moreText}>
                            + {data?.registeredNames?.length - 1} more
                          </PopperTrigger>
                          <PopperContent
                            noHeader={true}
                            iconRequired={false}
                            className={styles.popperContent}
                            arrowColor="var(--orange-oldlase)"
                          >
                            {data?.registeredNames
                              ?.filter((_, index) => index !== 0)
                              ?.map((name, index) => {
                                return (
                                  <div key={index} className={styles.popperText}>
                                    {name.trim()}
                                    {index == (data?.registeredNames?.length || 0) - 2 ? '' : ','}
                                  </div>
                                );
                              })}
                          </PopperContent>
                        </Popper>
                      )}
                    </span>
                  </>
                ) : (
                  'NA'
                )}
              </div>
            </div>
            <div className={styles.typeRegister}>Registered Name</div>
          </div>
          <div className={styles.topRightContainer}>
            <div className={styles.tbusinessName}>
              <div>
                <WorkIcon width={20} height={20} fill="var(--grayscale-3)" />
              </div>
              <div className={styles.tbusinessId}>
                {data?.businessTypes?.length ? (
                  <>
                    {data?.businessTypes[0]?.length > 18 ? (
                      <Tooltip
                        placement="top-start"
                        hiddenPadding={0}
                        hideStrategy="referenceHidden"
                      >
                        <TooltipTrigger asChild={true} ellipsis>
                          <div className={'max-w-[150px]'}>{data?.businessTypes[0]} </div>
                        </TooltipTrigger>
                        <TooltipContent className="tooltipWrapper">
                          {data?.businessTypes[0]}
                        </TooltipContent>
                      </Tooltip>
                    ) : (
                      data?.businessTypes[0]
                    )}
                    <span>
                      {data?.businessTypes?.length > 1 && (
                        <Popper placement="top">
                          <PopperTrigger className={styles.tbMoreText}>
                            + {data?.businessTypes?.length - 1} more
                          </PopperTrigger>
                          <PopperContent
                            noHeader={true}
                            iconRequired={false}
                            className={styles.popperContent}
                            arrowColor="var(--orange-oldlase)"
                          >
                            {data?.businessTypes
                              ?.filter((_, index) => index !== 0)
                              ?.map((name, index) => {
                                return (
                                  <div key={index} className={styles.popperText}>
                                    {name.trim()}
                                    {index == (data?.businessTypes?.length || 0) - 2 ? '' : ','}
                                  </div>
                                );
                              })}
                          </PopperContent>
                        </Popper>
                      )}
                    </span>
                  </>
                ) : (
                  'NA'
                )}
              </div>
            </div>
            <div className={styles.typeBusiness}>Type of Business</div>
          </div>
          <div className={styles.bottomLeftContainer}>
            <div className={styles.gstinContainer}>
              <div className={styles.gstinId}>
                <div>
                  <HashtagIcon />
                </div>
                <div className={styles.gstinSub}>
                  {data?.gstin ? data?.gstin : 'NA'}
                  <span className={styles.icon}>
                    <Tooltip placement="top">
                      <TooltipTrigger className="tooltipContent">
                        <Button variant="text" onClick={() => handleGstinCopy(data?.gstin || '')}>
                          {data?.gstin ? <CopyToClipboardIcon width={16} height={16} /> : null}
                        </Button>
                      </TooltipTrigger>
                      <TooltipContent className="tooltipWrapper" arrowColor={gstinTooltipArrow}>
                        {gstinTooltip}
                      </TooltipContent>
                    </Tooltip>
                  </span>
                </div>
              </div>
              <div className={styles.gstin}>GSTIN</div>
            </div>
          </div>
          <div className={styles.bottomMiddleContainer}>
            <div className={styles.emailContainer}>
              <div className={styles.emailId}>
                <div>
                  <MailIcon />
                </div>
                <div className={'flex flex-row gap-[4px]'}>
                  <div className={styles.emailSub}>
                    {data?.email ? (
                      data?.email?.length > 18 ? (
                        <Tooltip placement="top" hiddenPadding={0} hideStrategy="referenceHidden">
                          <TooltipTrigger className="tooltipContent" asChild={true} ellipsis>
                            <div>{data?.email}</div>
                          </TooltipTrigger>
                          <TooltipContent className="tooltipWrapper">{data?.email}</TooltipContent>
                        </Tooltip>
                      ) : (
                        data?.email
                      )
                    ) : (
                      'NA'
                    )}
                  </div>
                  <div className={styles.icon}>
                    <Tooltip placement="top">
                      <TooltipTrigger className="tooltipContent">
                        <Button
                          variant="text"
                          onClick={() => handleEmailCopy(data?.email || '')}
                          disabled={!data?.email}
                        >
                          {data?.email ? <CopyToClipboardIcon width={16} height={16} /> : null}
                        </Button>
                      </TooltipTrigger>
                      <TooltipContent className="tooltipWrapper" arrowColor={emailTooltipArrow}>
                        {emailTooltip}
                      </TooltipContent>
                    </Tooltip>
                  </div>
                </div>
              </div>
              <div className={styles.email}>Email Address</div>
            </div>
          </div>
          <div className={styles.bottomRightContainer}>
            <div className={styles.addressContainer}>
              <div className={styles.addressId}>
                <div>
                  <LocationOutlineIcon />
                </div>
                <div className={styles.address}>
                  {data?.businessAddress ? (
                    data?.businessAddress?.length > 20 ? (
                      <Tooltip
                        placement="top-start"
                        hiddenPadding={0}
                        hideStrategy="referenceHidden"
                      >
                        <TooltipTrigger className="tooltipContent" asChild={true} ellipsis>
                          <div> {data?.businessAddress} </div>
                        </TooltipTrigger>
                        <TooltipContent className="tooltipWrapper">
                          {data?.businessAddress}
                        </TooltipContent>
                      </Tooltip>
                    ) : (
                      data?.businessAddress
                    )
                  ) : (
                    'NA'
                  )}
                </div>
                <span className={styles.icon}>
                  <Tooltip placement="top">
                    <TooltipTrigger className="tooltipContent">
                      <Button
                        variant="text"
                        onClick={() => handleAddressCopy(data?.businessAddress || '')}
                        disabled={!data?.businessAddress}
                      >
                        {data?.businessAddress ? (
                          <CopyToClipboardIcon width={16} height={16} />
                        ) : null}
                      </Button>
                    </TooltipTrigger>
                    <TooltipContent className="tooltipWrapper" arrowColor={addressTooltipArrow}>
                      {addressTooltip}
                    </TooltipContent>
                  </Tooltip>
                </span>
              </div>
              <div className={styles.businnessAddress}>Business Address</div>
            </div>
          </div>
        </GridContainer>
      </div>
    </GridContainer>
  ) : null;
};

export default GstCard;
